/**
 * @class Oskari.mapframework.bundle.publisher2.view.PanelMapTools
 *
 * Represents the basic info (name, domain, language) view for the publisher
 * as an Oskari.userinterface.component.AccordionPanel
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.view.PanelMapTools',
/**
 * @method create called automatically on construction
 * @static
 */
function (group) {
  var tools = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var instance = arguments.length > 2 ? arguments[2] : undefined;
  var localization = arguments.length > 3 ? arguments[3] : undefined;
  this.group = group;
  this.tools = tools;
  this.tools.sort(function (a, b) {
    return a.getIndex() - b.getIndex();
  });
  this.loc = localization;
  this.instance = instance;
  this.templates = {
    tool: function tool(_ref) {
      var title = _ref.title;
      return "<div class=\"tool\">\n                <label><input type=\"checkbox\"/>".concat(title, "</label>\n                <div class=\"extraOptions\"></div>\n            </div>");
    },
    help: function help() {
      return '<div class="help icon-info"></div>';
    }
  };
}, {
  /**
   * Creates the set of Oskari.userinterface.component.FormInput to be shown on the panel and
   * sets up validation etc. Prepopulates the form fields if pData parameter is given.
   *
   * @method init
   * @param {Object} pData initial data
   * @returns {Boolean} if this panel has any tools/should be shown
   */
  init: function init(pData) {
    this.data = pData;
    if (!pData) {
      return;
    }
    this.tools.forEach(function (tool) {
      try {
        tool.init(pData);
      } catch (e) {
        Oskari.log('publisher2.view.PanelMapTools').error('Error initializing publisher tool:', tool.getTool().id);
      }
    });
    return this.tools.some(function (tool) {
      return tool.isDisplayed(pData);
    });
  },
  getName: function getName() {
    return 'Oskari.mapframework.bundle.publisher2.view.PanelMapTools';
  },
  /**
   * Returns the UI panel and populates it with the data that we want to show the user.
   *
   * @method getPanel
   * @return {Oskari.userinterface.component.AccordionPanel}
   */
  getPanel: function getPanel() {
    var _this = this;
    var me = this;
    var panel = Oskari.clazz.create('Oskari.userinterface.component.AccordionPanel');
    var contentPanel = panel.getContainer();
    var tooltipCont = jQuery(this.templates.help());
    panel.setTitle(me.loc[me.group].label);
    tooltipCont.attr('title', me.loc[me.group].tooltip);
    panel.getHeader().append(tooltipCont);

    // Add tools to panel
    this.tools.filter(function (tool) {
      return tool.isDisplayed(_this.data);
    }).forEach(function (tool) {
      var ui = jQuery(me.templates.tool({
        title: tool.getTitle()
      }));
      // setup values when editing an existing map
      ui.find('input').prop('checked', !!tool.isEnabled());
      ui.find('input').prop('disabled', !!tool.isDisabled());
      contentPanel.append(ui);
      ui.find('input').first().on('change', function () {
        var enabled = jQuery(this).is(':checked');
        // TODO: maybe wrap in try catch and on error show the user a message about faulty functionality
        tool.setEnabled(enabled);
        if (enabled) {
          ui.find('.extraOptions').show();
        } else {
          ui.find('.extraOptions').find('input').prop('checked', false);
          ui.find('.extraOptions').hide();
        }
      });
      var extraOptions = tool.getExtraOptions(ui);
      if (extraOptions) {
        ui.find('.extraOptions').append(extraOptions);
      }
      var initStateEnabled = ui.find('input').first().is(':checked');
      tool.setEnabled(initStateEnabled);
      if (initStateEnabled) {
        ui.find('.extraOptions').show();
      } else {
        ui.find('.extraOptions').hide();
      }
    });
    me.panel = panel;
    return panel;
  },
  /**
   * Returns the selections the user has done with the form inputs.
   * @method getValues
   * @return {Object}
   */
  getValues: function getValues() {
    // just return empty -> tools and their plugins' configs get returned by the layout panel, which has all the tools
    return null;
  },
  /**
   * Returns any errors found in validation or an empty
   * array if valid. Error object format is defined in Oskari.userinterface.component.FormInput
   * validate() function.
   *
   * @method validate
   * @return {Object[]}
   */
  validate: function validate() {
    return this.tools.filter(function (tool) {
      return !tool.validate();
    }).map(function (tool) {
      return tool.getTool().id;
    });
  },
  getTools: function getTools() {
    return this.tools;
  },
  /**
  * Stop panel.
  * @method stop
  * @public
  **/
  stop: function stop() {
    this.tools.forEach(function (tool) {
      try {
        tool.stop();
      } catch (e) {
        Oskari.log('publisher2.view.PanelMapTools').error('Error stopping publisher tool:', tool.getTool().id);
      }
    });
  }
});